import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStore } from "../stores/store";
import { UserPermissions } from "../models/user";

export default function RequireAuth() {
  const {
    commonStore: { isLoggedIn, isAuthorized },
  } = useStore();
  const location = useLocation();
  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} />;
  } else {
    if (
      (location.pathname.includes("orders") &&
        !isAuthorized(UserPermissions.viewOrders)) ||
      (location.pathname.includes("products") &&
        !isAuthorized(UserPermissions.addProducts)) ||
      (location.pathname.includes("users") &&
        !isAuthorized(UserPermissions.addUsers)) ||
      (location.pathname.includes("tickets") &&
        !isAuthorized(UserPermissions.tickets)) ||
      (location.pathname.includes("shipping") &&
        !isAuthorized(UserPermissions.shipping)) ||
      (location.pathname.includes("settings") &&
        !isAuthorized(UserPermissions.settings))
    ) {
      return <Navigate to="not-found" state={{ from: location }} />;
    }
    return <Outlet />;
  }
}
